import { get } from "lodash-es";
import { useRuntimeConfig } from "#imports";

const JAPAN_STYLE_VALUES = new Set([
  "japan",
  "jp",
  "japanese",
  "japanstyle",
  "japan-style",
  "日本",
  "日本风格",
  "日本風格",
  "日式",
  "日系",
]);

const AUSTRALIA_STYLE_VALUES = new Set([
  "australia",
  "au",
  "australian",
  "australiastyle",
  "australia-style",
  "澳洲",
  "澳洲风格",
  "澳洲風格",
]);

function normalizeShopStyleValue(value) {
  if (value === null || typeof value === "undefined") {
    return "";
  }

  return String(value).trim().toLowerCase().replace(/\s+/g, "");
}

function pickFirstMeaningfulValue(values = []) {
  return values.find((item) => item !== null && typeof item !== "undefined" && String(item).trim() !== "");
}

function readDevShopStyleOverride() {
  if (process.env.NODE_ENV !== "development") {
    return "";
  }

  try {
    const runtimeConfig = useRuntimeConfig();
    const runtimeValue = runtimeConfig?.public?.devShopStyle;
    if (String(runtimeValue || "").trim()) {
      return runtimeValue;
    }
  } catch (error) {
    // Ignore missing Nuxt runtime context and fall through to client-side fallback.
  }

  if (typeof window !== "undefined") {
    return window.__NUXT__?.config?.public?.devShopStyle || "";
  }

  return "";
}

function parseConfigData(configData) {
  if (!configData) {
    return {};
  }

  if (typeof configData === "string") {
    try {
      return JSON.parse(configData);
    } catch (error) {
      return {};
    }
  }

  return configData;
}

export function resolveShopStyle(storeInfo = {}) {
  const parsedConfigData = parseConfigData(get(storeInfo, "configData"));
  const devShopStyleOverride = readDevShopStyleOverride();

  const configStyle = pickFirstMeaningfulValue([
    devShopStyleOverride,
    get(parsedConfigData, "shopStyle"),
    get(parsedConfigData, "storeStyle"),
    get(parsedConfigData, "themeStyle"),
    get(storeInfo, "shopStyle"),
    get(storeInfo, "storeStyle"),
    get(storeInfo, "themeStyle"),
    get(storeInfo, "style"),
    get(storeInfo, "appSetting.shopManage.shopStyle"),
    get(storeInfo, "appSetting.shopManage.storeStyle"),
    get(storeInfo, "shopManage.shopStyle"),
    get(storeInfo, "shopManage.storeStyle"),
  ]);

  return {
    raw: configStyle || "",
    normalized: normalizeShopStyleValue(configStyle),
  };
}

export function isJapanShopStyle(storeInfo = {}) {
  const { normalized } = resolveShopStyle(storeInfo);
  return JAPAN_STYLE_VALUES.has(normalized);
}

export function isAustraliaShopStyle(storeInfo = {}) {
  const { normalized } = resolveShopStyle(storeInfo);
  return AUSTRALIA_STYLE_VALUES.has(normalized);
}
